export const LeftAlign = ({ height }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H3Z"
        fill="#000000"
      />
      <path
        d="M3 13C2.44772 13 2 13.4477 2 14C2 14.5523 2.44772 15 3 15H21C21.5523 15 22 14.5523 22 14C22 13.4477 21.5523 13 21 13H3Z"
        fill="#000000"
      />
      <path
        d="M2 10C2 9.44772 2.44772 9 3 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H3C2.44772 11 2 10.5523 2 10Z"
        fill="#000000"
      />
      <path
        d="M3 17C2.44772 17 2 17.4477 2 18C2 18.5523 2.44772 19 3 19H15C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17H3Z"
        fill="#000000"
      />
    </svg>
  );
};

export const CenterAlign = ({ height }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H3Z"
        fill="#000000"
      />
      <path
        d="M3 13C2.44772 13 2 13.4477 2 14C2 14.5523 2.44772 15 3 15H21C21.5523 15 22 14.5523 22 14C22 13.4477 21.5523 13 21 13H3Z"
        fill="#000000"
      />
      <path
        d="M5 10C5 9.44772 5.44772 9 6 9H18C18.5523 9 19 9.44772 19 10C19 10.5523 18.5523 11 18 11H6C5.44772 11 5 10.5523 5 10Z"
        fill="#000000"
      />
      <path
        d="M6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17H6Z"
        fill="#000000"
      />
    </svg>
  );
};

export const RightAligh = ({ height }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H3Z"
        fill="#000000"
      />
      <path
        d="M3 13C2.44772 13 2 13.4477 2 14C2 14.5523 2.44772 15 3 15H21C21.5523 15 22 14.5523 22 14C22 13.4477 21.5523 13 21 13H3Z"
        fill="#000000"
      />
      <path
        d="M8 10C8 9.44772 8.44772 9 9 9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H9C8.44772 11 8 10.5523 8 10Z"
        fill="#000000"
      />
      <path
        d="M9 17C8.44772 17 8 17.4477 8 18C8 18.5523 8.44772 19 9 19H21C21.5523 19 22 18.5523 22 18C22 17.4477 21.5523 17 21 17H9Z"
        fill="#000000"
      />
    </svg>
  );
};
